// @module nowakdental.ADAComplaince.ADAComplaince
define('nowakdental.ADAComplaince.ADAComplaince.View'
,	[
	'nowakdental_adacomplaince_adacomplaince.tpl'
	
	,	'nowakdental.ADAComplaince.ADAComplaince.SS2Model'
	
	,	'Backbone'
    ]
, function (
	nowakdental_adacomplaince_adacomplaince_tpl
	
	,	ADAComplainceSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class nowakdental.ADAComplaince.ADAComplaince.View @extends Backbone.View
	return Backbone.View.extend({

		template: nowakdental_adacomplaince_adacomplaince_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new ADAComplainceModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
			// ADA fixes are applied from the extension entry point (mountToApp).
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return nowakdental.ADAComplaince.ADAComplaince.View.Context
	,	getContext: function getContext()
		{
			//@class nowakdental.ADAComplaince.ADAComplaince.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
